import React, { useEffect, useState } from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getHistory } from "../../../redux/slice/historySlice";
import { getLeaderBoard } from "../../../redux/slice/leaderboardSlice";
import { getExamID, submitExam } from "../../../redux/slice/examSlice";
import { getUserID } from "../../../redux/slice/userSlice";
import ExitExamButton from "./ExitExamButton";
import SubmitExamButton from "./SubmitExamButton";
import Timer from "./Timer";

const ExamForm = ({ examQuestions }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(1);
  const [answer, setAnswer] = useState([]);

  const userID = useSelector(getUserID);

  const examID = useSelector(getExamID);

  const itemsPerPage = 2;
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(itemsPerPage);

  const len = examQuestions?.length;

  const handleNext = () => {
    setStartIndex((prev) => prev + itemsPerPage);
    setEndIndex((prev) => prev + itemsPerPage);
  };

  const handlePrevious = () => {
    setStartIndex((prev) => prev - itemsPerPage);
    setEndIndex((prev) => prev - itemsPerPage);
  };

  const handleOptionChange = (e) => {
    const questionID = e.target.name;
    const answerID = e.target.id;

    answer.some((ans) => ans.questionID === questionID)
      ? setAnswer(
          answer.map((ans) =>
            ans.questionID === questionID ? { ...ans, answerID } : ans
          )
        )
      : setAnswer([...answer, { questionID, answerID }]);
  };

  const submitByTimer = async (data) => {
    const result = await dispatch(submitExam(data)).unwrap();
    dispatch(getHistory(data.user));
    dispatch(getLeaderBoard());
    navigate(`/client/result/${result.data.submitId}`);
  };

  useEffect(() => {
    if (seconds + minutes <= 0) {
      const data = {
        user: userID,
        exam: examID,
        submittedAnswer: answer,
      };
      submitByTimer(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seconds, minutes, userID, examID, answer, dispatch, navigate]);

  return (
    <>
      <div className="sticky top-6 sm:self-center self-end">
        <Timer
          minutes={minutes}
          setMinutes={setMinutes}
          seconds={seconds}
          setSeconds={setSeconds}
          time={10 * 60 * 1000}
        />
        <span className="text-textSecondary">Total Questions: {len}</span>
      </div>
      <div className="sm:px-8">
        {examQuestions
          ?.slice([startIndex], [endIndex])
          .map((question, index) => (
            <div key={question._id} className="pb-6">
              <div className="flex flex-col pb-1">
                <p className="text-textPrimary font-medium text-[18px]">
                  {index + startIndex + 1}. {question.questions}
                </p>
              </div>
              <div className="flex flex-col gap-2 pl-6">
                {question?.optionsOfAnswer?.map((option) => (
                  <div
                    key={option._id}
                    className="flex flex-row gap-3 items-center"
                  >
                    <input
                      type="radio"
                      name={question._id}
                      id={option._id}
                      value={option.option}
                      onChange={handleOptionChange}
                      className="h-[16px] w-[16px]"
                      checked={answer.some(
                        (ans) => ans.answerID === option._id
                      )}
                    />
                    <label htmlFor={option._id} className="font-[18px]] ">
                      {option.option}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
      <div className="flex justify-between items-center">
        {startIndex !== 0 ? (
          <button
            onClick={handlePrevious}
            className="flex flex-row items-center justify-center gap-2 h-[36px] rounded-md text-sm pr-[36px] pl-[24px] font-semibold border-2 border-secondary text-secondary"
          >
            <FaAngleLeft />
            <span>Prev</span>
          </button>
        ) : (
          <ExitExamButton
            message="Exit"
            styles="border-2 border-red-500 text-red-500"
          />
        )}
        {endIndex < len ? (
          <button
            onClick={handleNext}
            className="flex flex-row items-center justify-center gap-2 h-[36px] rounded-md text-sm pl-[38px] pr-[24px] font-semibold border-2 border-secondary bg-transparent text-secondary"
          >
            <span>Next</span>
            <FaAngleRight />
          </button>
        ) : (
          <SubmitExamButton
            message="Submit"
            data={{
              user: userID,
              exam: examID,
              submittedAnswer: answer,
            }}
            styles="border-2 border-secondary bg-secondary text-primary"
          />
        )}
        {/* </div> */}
      </div>
    </>
  );
};

export default ExamForm;
